// @flow
import { isNumber } from "./isNumber";
import { isLength } from "./String";

const is8Long = isLength(8);

export const isBankCode = [is8Long, isNumber];
